export default {
  model: [
    {
      label: 'Nome',
      field: 'name',
      type: 'text'
    },
    {
      label: 'Situação do usuário',
      field: 'status',
      type: 'text'
    },
    {
      label: 'Login',
      field: 'login',
      type: 'text'
    },
    {
      label: 'Senha',
      field: 'password',
      type: 'text',
      password: true,
      condition_field: 'id',
      condition_type_exists: false
    },
    {
      label: 'Confirmar senha',
      field: 'confirm_password',
      type: 'text',
      condition_field: 'id',
      condition_type_exists: false
    },
    {
      label: 'Tipo de usuário',
      field: 'user_type_id',
      type: 'text'
    }
  ]
}